import React from "react";
import { Redirect } from "react-router-dom";
import ROUTES from "../../../../core/constants/routes.constants";

function Logout() {
  return <Redirect to={ROUTES.root} />;
}

export default Logout;
